<template>
  <v-toolbar dense flat height="32">
    <slot name="left"></slot>
      <v-tooltip bottom v-for="toolbar of toolbarList">
        <template v-slot:activator="{ on, attrs }">
          <v-spacer v-if="toolbar.toolbar_name === 'space'"></v-spacer>
          <v-btn
            v-if="toolbar.toolbar_name === 'action' && (!toolbar.only_modal || state.modalDialog)"
            v-on="on"
            small
            elevation="2"
            :color="toolbar.color"
            dense
            class="mx-1"
            @click="onAction(toolbar.action_name)"
            :disabled="isDisabled(toolbar)"
        >
          <v-icon v-if="!!toolbar.icon" :color="toolbar.icon_color">{{ toolbar.icon }}</v-icon>
          <span v-if="!!toolbar.label">{{ toolbar.label }}</span>
        </v-btn>
          <v-row class="flex-nowrap" v-if="toolbar.toolbar_name === 'filter_list'">
            <v-btn-toggle
              dense
              v-model="statusGroup"
              multiple
              @change="onChange(toolbar)"
          >
            <v-tooltip bottom v-for="item of toolbar.filter_list">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-on="on" small elevation="2" :color="item.color" dense>
                  <v-icon :color="item.icon_color">{{ item.icon }}</v-icon>
                  {{ item.label }}
                  <small class="mt-1">{{ getByFilterCount(item) }}</small>
                </v-btn>
              </template>
              <span v-if="!!item.text">{{ item.text }}</span>
              <span v-else>{{ item.label }}</span>
            </v-tooltip>
          </v-btn-toggle>
            <v-btn
                v-if="statusGroup.length > 0"
                small
                icon
                @click="statusGroup=[]; onChange(toolbar)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
      </template>
      <span v-if="!!toolbar.text">{{ toolbar.text }}</span>
    </v-tooltip>
    <slot name="right"></slot>
  </v-toolbar>
</template>

<script>

import {defineStore} from "pinia";

export const useToolbarStore = function (storeName) {
  return defineStore(storeName, {
        state: () => ({
          topToolbar: [],
          bottomToolbar: [],
          modalDialog: true,
          selectedItems: [],
        }),
        getters: {},
        actions: {
          callReceive() {
            this.loading = false
          },
          callBack() {
          },
        },
      }
  )
}

export default {
  name: 'CommonToolbar',
  inheritAttrs: false,
  props: {
    storeName: {type: [String]},
    bottom: {default: false},
    top: {default: false},
  },

  components: {},

  computed: {
    toolbarList() {
      if (this.bottom)
        return this.state.bottomToolbar
      if (this.top)
        return this.state.topToolbar
      return []
    },
  },

  methods: {
    getByFilterCount(filterItem) {
      return filterItem.count
    },
    onChange(toolbar) {
      // console.log('onChange', toolbar)
      let activeFilterNames = []
      this.statusGroup.forEach(row => activeFilterNames.push(toolbar.filter_list[row].name))
      this.$emit('update:filter-names', activeFilterNames)
    },
    onAction(action_name) {
      // console.log('Action event', action_name)
      if (action_name.includes('embedded_'))
        this.$emit(action_name)
      else
        this.$emit('action', action_name)
    },
    isDisabled(toolbar) {
      if (toolbar.disabled)
        return true
      if (toolbar.show_only_selected && this.state.selectedItems.length === 0)
        return true
      return false
    },
  },

  setup({storeName}) {
    let state = useToolbarStore(storeName)()
    return {state}
  },

  async mounted() {
  },

  data() {
    return {
      statusGroup: []
    }
  }
}
</script>

